import logoUrl from "../../assets/branding/empreitaflow-logo.png";

export function BrandLogo({
  variant = "mark",
  className = "",
}: {
  variant?: "mark" | "full";
  className?: string;
}) {
  return (
    <img
      className={`brand-logo brand-logo--${variant} ${className}`}
      src={logoUrl}
      alt="EmpreitaFlow"
      width={variant === "mark" ? 40 : 360}
      height={variant === "mark" ? 40 : 360}
    />
  );
}
